"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccountChange = void 0;
const tslib_1 = require("tslib");
const api_1 = require("src/api");
const useAccountStructuralUnit_1 = tslib_1.__importDefault(require("src/modules/menu/hooks/useAccountStructuralUnit"));
const useAccountChange = (props) => {
    const accountHook = (0, useAccountStructuralUnit_1.default)({ user: props.authUser });
    const getAuthUserForDebug = async () => {
        const response = await api_1.Auth.getAuthUser();
        if (response.data) {
            localStorage.setItem('activeStructuralUnitId', response.data.accountId || '');
        }
        else {
            localStorage.removeItem('token');
            localStorage.removeItem('activeStructuralUnitId');
            localStorage.removeItem('authenticate');
        }
        return response;
    };
    const loginAsEmulateUserForDebug = async (userId) => {
        const response = await api_1.UsersApi.loginAs(userId, { client_id: '1', grant_type: 'emulate' });
        if (response.data !== null) {
            localStorage.removeItem('activeStructuralUnitId');
            localStorage.setItem('token', JSON.stringify(response.data));
            await getAuthUserForDebug();
        }
        return { errors: response.errors, status: response.status };
    };
    const logoutAsEmulateUserForDebug = async (userId) => {
        const response = await api_1.UsersApi.loginAsUser({ id: userId, client_id: '1', grant_type: 'emulate' });
        localStorage.removeItem('activeStructuralUnitId');
        localStorage.setItem('token', JSON.stringify(response.data));
        if (response.data !== null) {
            await getAuthUserForDebug();
        }
        return response;
    };
    const changeUserOrAccount = async (structuralUnitNameDev, structuralUnitNameStaging, account) => {
        if (account && account.id === props.authUser?.accountId)
            return null;
        if (account && account.id !== props.authUser?.accountId) {
            await accountHook.changeActiveAccount(account);
            await getAuthUserForDebug();
        }
        else {
            const structuralUnitsDev = await api_1.StructuralUnitsUpgradedApi.getStructuralUnits({ filters: { keyword: structuralUnitNameDev }, perPage: 30 });
            if (structuralUnitsDev.data?.length === 0) {
                const structuralUnitsStaging = await api_1.StructuralUnitsUpgradedApi.getStructuralUnits({ filters: { keyword: structuralUnitNameStaging }, perPage: 30 });
                if (structuralUnitsStaging.data && structuralUnitsStaging.data.length > 0) {
                    const acc = await loginAsEmulateUserForDebug(structuralUnitsStaging.data[0].user.id);
                    if (acc) {
                        const authUserAcc = await getAuthUserForDebug();
                        if (authUserAcc.data) {
                            await accountHook.changeActiveAccount(authUserAcc.data.accounts.find(el => el.name === structuralUnitNameStaging));
                            return authUserAcc.data.emulatedBy;
                        }
                    }
                }
            }
            else {
                if (structuralUnitsDev.data && structuralUnitsDev.data.length > 0) {
                    const acc = await loginAsEmulateUserForDebug(structuralUnitsDev.data[0].user.id);
                    if (acc) {
                        const authUserAcc = await getAuthUserForDebug();
                        if (authUserAcc.data) {
                            await accountHook.changeActiveAccount(authUserAcc.data.accounts.find(el => el.name === structuralUnitNameDev));
                            return authUserAcc.data.emulatedBy;
                        }
                    }
                }
            }
        }
        return null;
    };
    return {
        changeUserOrAccount,
        getAuthUserForDebug,
        logoutAsEmulateUserForDebug,
        loginAsEmulateUserForDebug
    };
};
exports.useAccountChange = useAccountChange;
